import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Delivery from "./Component/Delivery";
import CustomService from "./Component/CustomService";
import Orders from "./Component/Orders";
import OrderDetail from "./Component/OrderDetail";
import OrderLogin from "./Component/OrderLogin";
import {
  OrderAuthProvider,
  RequireOrderAuth,
} from "./Component/OrderAuthContext";

function App() {
  return (
    <CartProvider>
      <OrderAuthProvider>
        <Router>
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/" element={<Main />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
            <Route path="/custom_service" element={<CustomService />} />
            <Route path="/order-login" element={<OrderLogin />} />
            <Route
              path="/orders"
              element={
                <RequireOrderAuth>
                  <Orders />
                </RequireOrderAuth>
              }
            />
            <Route
              path="/orders/:id"
              element={
                <RequireOrderAuth>
                  <OrderDetail />
                </RequireOrderAuth>
              }
            />
          </Routes>
        </Router>
      </OrderAuthProvider>
    </CartProvider>
  );
}

export default App;
